import { LogConfig, logIntervalMs } from '../types/log-config';
import { utcDate } from './time-functions';

export const DEVICE_STATUS_COLORS = {
    unknown: '#9e9e9e', // интервал не определён или неизвестно время последней передачи
    ok: '#4caf50', // уложился в интервал (+20%)
    warning: '#ff9800', // пропущена одна передача
    overdue: '#f44336', // данных нет дольше двух интервалов
} as const;

/**
 * Цвет индикатора состояния устройства по времени последней передачи и интервалу логирования.
 */
export function getDeviceStatusColor(lastTransaction: string, logConfig: LogConfig | null | undefined): string {
    const lastDate = utcDate(lastTransaction);
    const intervalMs = logIntervalMs(logConfig);
    if (!lastDate || intervalMs === null) return DEVICE_STATUS_COLORS.unknown;

    const lastMs = lastDate.valueOf();
    const nowMs = Date.now();

    if (nowMs < lastMs + intervalMs * 1.2) return DEVICE_STATUS_COLORS.ok;
    if (nowMs < lastMs + intervalMs * 2) return DEVICE_STATUS_COLORS.warning;
    return DEVICE_STATUS_COLORS.overdue;
}
